import { z } from 'zod'
import { stringSchema } from './common'

export const breadcrumbsSchema = z.array(
  z.object({
    title: stringSchema.min(1),
    path: stringSchema.min(1),
  }),
)
